import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const adminModify = ({ kind, data = {} }, opts = {}) =>
  swRequest(
    {
      path: "/api/admin/modify",
      method: "POST",
      body: { kind, data },
    },
    opts,
  );

export const getTeam = (params = {}, opts = {}) =>
  swRequest(
    {
      path: "/api/admin/get_team",
      params,
    },
    opts,
  );

export const adminCreate = ({ kind, data }) =>
  swRequest({
    path: "/api/admin/create",
    method: "POST",
    body: { kind, data },
  });

export const adminFeaturePricing = (params, opts = {}) =>
  swRequest(
    {
      path: "/api/admin/get_feature_pricing",
      params,
    },
    opts,
  );

export const adminAddLicensesAbandoned = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/admin/add_licenses_abandoned",
      method: "POST",
      body,
    },
    opts,
  );
